import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RouterModule } from '@angular/router'; 

import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';


@Component({
    selector: 'entity-chooser',
    templateUrl: 'entity-chooser.html',
    standalone: true,
    imports: [
      MatIconModule,
      RouterModule,
      MatGridListModule
    ]
  })
  export class EntityChooserDialog {

    constructor(
      public dialogRef: MatDialogRef<EntityChooserDialog>,
      @Inject(MAT_DIALOG_DATA) public data) {

      }


    onNoClick(): void {
      this.dialogRef.close();
    }

  }
